<template>
  <div
    v-if="isVisible"
    class="p-the-a01-gift-merit"
    :class="{ 'is-open': isOpen }"
    :style="{ '--site-color': colorCode }"
  >
    <div class="p-the-a01-gift-merit__summary">
      <div class="p-the-a01-gift-merit__heading">
        <IconBase
          class="p-the-a01-gift-merit__icon"
          :width="24"
          :height="24"
          view-box="0 0 24 24"
          :icon-color="colorCode"
        >
          <IconCheckBoxFilled />
        </IconBase>
        <p class="p-the-a01-gift-merit__title">
          <span data-translate-skip>{{ pointName }}</span>を贈るメリット
        </p>
      </div>
      <button
        v-if="isSp"
        type="button"
        class="p-the-a01-gift-merit__toggle"
        :aria-expanded="isOpen"
        aria-controls="gift-merit-body"
        @click="toggle"
      >
        <IconBase
          class="p-the-a01-gift-merit__chevron"
          :width="24"
          :height="24"
          view-box="0 0 24 24"
          icon-color="#1f2021"
        >
          <IconArrowBottom />
        </IconBase>
      </button>
    </div>
    <div
      id="gift-merit-body"
      class="p-the-a01-gift-merit__body"
    >
      <p class="p-the-a01-gift-merit__text" data-translate-skip>
        {{ giftMerit }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCheckBoxFilled from "@/common/components/icons/IconCheckBoxFilled.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import commons from "@/common/store/modules/commons";
import auth from "@/general/store/modules/auth";
import globals from "@/general/store/modules/globals";

@Options({
  components: {
    IconBase,
    IconCheckBoxFilled,
    IconArrowBottom
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TheA01GiftMeritPanel extends Vue {
  isOpen = true;
  storeColorCode!: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get isSp() {
    return globals.isSpScreenWidth;
  }

  get giftMerit() {
    return auth.user?.gift_merit || "";
  }

  get pointName() {
    return commons.OrgPageSpecific?.point_name || commons?.unit?.point;
  }

  get isVisible() {
    return this.giftMerit.trim().length > 0;
  }

  toggle() {
    if (this.isSp) {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-gift-merit {
  display: flex;
  flex-direction: column;
  gap: rem(8);
  width: 100%;
  margin-top: rem(24);

  &__summary {
    display: flex;
    gap: rem(4);
    align-items: center;
    width: 100%;
  }

  &__heading {
    display: flex;
    flex: 1 0 0;
    gap: rem(4);
    align-items: center;
    min-width: 0;
  }

  &__icon {
    flex-shrink: 0;
    width: rem(24);
    height: rem(24);
  }

  &__title {
    color: var(--site-color);
    font-family: $font--noto-sans-only;
    font-size: rem(20);
    font-weight: 700;
    line-height: 1.5;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;
  }

  &__toggle {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: inherit;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__chevron {
    flex-shrink: 0;
    width: rem(24);
    height: rem(24);
    transition: transform $transition-sec--fast ease-in;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: rem(8);
    width: 100%;
  }

  &__text {
    width: 100%;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 400;
    line-height: 1.8;
    white-space: pre-line;
    overflow-wrap: break-word;
    font-feature-settings: "pwid" 1, "palt" 1;
  }

  @include sp {
    gap: 0;
    margin-top: rem(16);
    overflow: hidden;
    background-color: $common-white;
    border: px(1) solid #f4f5f6;
    border-radius: rem(8);
    box-shadow: 0 0 rem(4) rgba($common-black, 0.1);

    &__summary {
      gap: rem(16);
      padding: rem(16);
    }

    &__title {
      font-size: rem(16);
      white-space: normal;
    }

    &.is-open &__chevron {
      transform: rotate(180deg);
    }

    &__body {
      display: none;
      gap: rem(16);
      padding: rem(16);
      background-color: #f4f5f6;
    }

    &.is-open &__body {
      display: flex;
    }

    &__text {
      font-size: rem(14);
    }
  }
}
</style>
